import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { config } from '../config';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { initFacebookPixels, trackEventOnMultiplePixels,  } from '../pixel';
import { FaCheckCircle, FaFacebook, FaWhatsapp, FaTelegram, FaYoutube,  FaCoins, FaShoppingBag, FaUserAlt, FaTruck, FaGift, FaExclamationTriangle, FaPlusCircle,FaMinusCircle } from 'react-icons/fa';
import { HeaderContext } from '../context/HeaderContext';
import { ProductContext } from '../context/ProductsContext';
import * as FaIcons from "react-icons/fa";
import { useCart } from 'react-use-cart';

const ThankYou = () => {
  const [orderDetails, setOrderDetails] = useState(null);
  const {id} = useParams();
  const pixelInitialized = useRef(false);
  const [pixelId, setPixelId] = useState('');
  const [showCoinAnimation, setShowCoinAnimation] = useState(false);
  const [phone, setPhone] = useState('');
  const [loginError, setLoginError] = useState('');
  const [user, setUser] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [communities, setCommunities] = useState([]);

  // Remove any unwanted characters like '{' and '}' from the id
  const sanitizedId = id.replace(/[{}]/g, '');


  const {bonus, users, loading: headerLoading} = useContext(HeaderContext);
  const { pixel,testEventCode, apiUrl, loading: productLoading, setLoading, products } = useContext(ProductContext);



   // Helper function to get cookies
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const getFBC = () => {
      return getCookie('_fbc') || localStorage.getItem('fbc') || null;
    };

    const getFBP = () => {
      return getCookie('_fbp') || localStorage.getItem('fbp') || null;
    };


    // ফোন নাম্বার ফরম্যাট করার ফাংশন
    const formatPhoneForFacebook = (phone) => {
    if (!phone) return '';
    // শুধুমাত্র নাম্বার রাখুন
    const digitsOnly = phone.replace(/\D/g, '');
    // বাংলাদেশী নাম্বার হলে 880 যোগ করুন
    if (digitsOnly.length === 11 && !digitsOnly.startsWith('880')) {
        return `880${digitsOnly.substring(1)}`;
    }
    return digitsOnly;
    };


    const extractDistrict = (address) => {
      if (!address) return '';
      const match = address.match(/district:\s*([^,]+)/i);
      return match ? match[1].trim() : '';
    };

    const extractDivision = (address) => {
      if (!address) return '';
      const match = address.match(/division:\s*([^,]+)/i);
      return match ? match[1].trim() : '';
    };

    console.log('Order Details:', orderDetails);


    const buildContentsForPixel = (orderDetails) => {
      let contents = [];

      // Main products
      if (orderDetails?.items?.length > 0) {
        contents = orderDetails.items.map(item => ({
          id: item.product_id,
          quantity: item.quantity,
          item_price: Number(item.price)
        }));
      } else {
        contents.push({
          id: orderDetails?.product_id,
          quantity: Number(orderDetails?.quantity || 1),
          item_price: Number(orderDetails?.product_price)
        });
      }

      // Order bumps
      if (orderDetails?.order_bumps?.length > 0) {
        orderDetails.order_bumps.forEach(bump => {
          contents.push({
            id: `bump_${bump.bump_id}`, // important: unique id
            quantity: 1,
            item_price: Number(bump.price)
          });
        });
      }

      return contents;
    };


    const buildContentIds = (orderDetails) => {
      let ids = [];

      if (orderDetails?.items?.length > 0) {
        ids = orderDetails.items.map(item => item.product_id);
      } else if (orderDetails?.product_id) {
        ids.push(orderDetails.product_id);
      }

      if (orderDetails?.order_bumps?.length > 0) {
        orderDetails.order_bumps.forEach(bump => {
          ids.push(`bump_${bump.bump_id}`);
        });
      }

      return ids;
    };

    const contents = buildContentsForPixel(orderDetails);
    const contentIds = buildContentIds(orderDetails);


  // পিক্সেল ইনিশিয়ালাইজেশন এবং Purchase ট্র্যাকিং
  useEffect(() => {
    // পিক্সেল এবং অর্ডার ডিটেইলস থাকলে এবং আগে ফায়ার না হয়ে থাকলে এটি রান করবে
    if (pixel && pixel.length > 0 && orderDetails && !pixelInitialized.current) {

      const contents = buildContentsForPixel(orderDetails);
      const contentIds = buildContentIds(orderDetails);

      // Value ঠিকঠাক নাম্বারে কনভার্ট করা (যদি 1,500 এরকম কমা থাকে, তবে তা রিমুভ করে)
      const orderValue = parseFloat(String(orderDetails?.total || '0').replace(/,/g, ''));

      // ১. শুধুমাত্র Browser Pixel এর জন্য (এখানে কোনো PII/User Data থাকা যাবে না)
      const browserEventData = {
        value: orderValue,
        currency: 'BDT',
        content_name: orderDetails?.product_name || '',
        content_ids: contentIds,
        contents: contents,
        num_items: contents.length,
        content_type: 'product'
      };

      // ২. Server-side CAPI এর জন্য (এখানে ইউজারের ব্যক্তিগত তথ্যসহ সব থাকবে)
      const capiEventData = {
        ...browserEventData, // উপরের ডাটাগুলোও যোগ হবে
        email: localStorage.getItem('email') || '',
        phone: formatPhoneForFacebook(orderDetails?.phone_number || ''),
        name: orderDetails?.customer_name || '',      
        city: extractDistrict(orderDetails?.customer_address),
        state: extractDivision(orderDetails?.customer_address),
        event_source_url: window.location.href,
        fbc: getFBC(),
        fbp: getFBP(),
        event_id: orderDetails?.order_id || '',
        external_id: orderDetails?.id ? String(orderDetails.id) : formatPhoneForFacebook(orderDetails?.phone_number || ''), 
        event_time: Math.floor(Date.now() / 1000),
      };

      // Client-side Pixel Tracking (শুধুমাত্র Standard Data পাঠাচ্ছি)
      trackEventOnMultiplePixels(pixel, 'Purchase', {
        ...browserEventData,
        event_id: orderDetails?.order_id 
      });



      // Server-side CAPI Tracking (এখানে ফুল ডাটা পাঠাচ্ছি)
      axios.post(`${apiUrl}/fb-track`, {
        event: 'Purchase',
        ...capiEventData,
        ...(testEventCode?.[0] && { test_event_code: testEventCode[0] }),
      }).catch(err => console.error("CAPI Tracking Error:", err));

      pixelInitialized.current = true; // নিশ্চিত করুন যে পিক্সেল ইনিশিয়ালাইজেশন একবারই হবে

    }
  }, [pixel, orderDetails, apiUrl]);




  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if (sanitizedId) {
        try {
          const response = await axios.get(`${apiUrl}/customers/${sanitizedId}`);
          const customersResponse = await axios.get(`${apiUrl}/customers`);

          const allCustomers = customersResponse.data.customers;
          const usercustomer = allCustomers.filter(customer => customer.phone_number === response.data.customer.phone_number);

          setOrderDetails(response.data.customer);

          if (usercustomer.length > 1) {
            setIsUser(true);
          }
          
          // Show coin animation after 1 second only if not logged in
          if (!localStorage.getItem('authToken')) {
            setTimeout(() => setShowCoinAnimation(true), 1000);
          }
        } catch (error) {
          console.error("Error fetching order details:", error?.response?.data?.message);
        }
      } else {
        console.error("Invalid order ID:", sanitizedId);
      }
    };

    fetchOrderDetails();
  }, [apiUrl, sanitizedId]);



  useEffect(() => {
    const fetchCommunity = async () => {
        try {
          const response = await axios.get(`${apiUrl}/communities`);

          setCommunities(response.data);
          
        } catch (error) {
          console.error("Error fetching order details:", error?.response?.data?.message);
        }
    };

    fetchCommunity();
  }, [apiUrl]);


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');

    if (!phone.match(/^01[3-9]\d{8}$/)) {
      setLoginError('সঠিক মোবাইল নম্বর দিন (১১ ডিজিট, 01 দিয়ে শুরু)');
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/userlogin`, { phone });
      
      if (response.data.user) {
        setUser(response.data.user);
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('phone', phone);
        setIsLoggedIn(true);
        setLoginOpen(false);
        window.location.reload();
      } else {
        setLoginError('লগইন সফল হয়নি');
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setLoginError('এই নম্বর দিয়ে কোন ইউজার নেই');
      } else {
        setLoginError('লগইনে সমস্যা হয়েছে, পরে চেষ্টা করুন');
        console.error('Login error:', err);
      }
    }
  };

  if (headerLoading || productLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-green-500"></div>
      </div>
    );
  }

  if (!orderDetails) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-gray-50 min-h-screen flex items-center justify-center">
        <div className="container mx-auto text-center px-4">
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-2xl mx-auto">
            <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
            <h1 className="text-2xl lg:text-4xl font-bold text-blue-900 mb-4">
              ধন্যবাদ! আপনার অর্ডারটি গ্রহণ করা হয়েছে।
            </h1>
            <p className="text-lg text-gray-600 mb-6">
              আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব।
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
              <p className="text-yellow-700 font-medium">
                অর্ডার ডিটেইলস পাওয়া যায়নি। অনুগ্রহ করে আমাদের কাস্টমার কেয়ারে যোগাযোগ করুন।
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />

      {loginOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden animate-fadeIn">
            {/* Form Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 text-center">
              <h2 className="text-2xl font-bold text-white">লগইন করুন</h2>
              <p className="text-blue-100 mt-1">{bonus.coin_name} ব্যবহার করতে লগইন করুন</p>
            </div>

            {/* Form Body */}
            <div className="p-6">
              <form onSubmit={handleLogin}>
                <div className="mb-6">
                  <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="phone">
                    মোবাইল নম্বর
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-500">+88</span>
                    </div>
                    <input
                      type="tel"
                      id="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="01XXXXXXXXX"
                      className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                      required
                    />
                  </div>
                </div>

                {loginError && (
                  <div className="mb-4 bg-red-50 border-l-4 border-red-500 p-3 rounded">
                    <div className="flex items-center">
                      <svg className="h-5 w-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                      <span className="text-red-700 font-medium">{loginError}</span>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium py-3 px-4 rounded-lg shadow-md transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  লগইন
                </button>
              </form>

              <div className="mt-6 text-center">
                <button 
                  onClick={() => setLoginOpen(false)}
                  className="text-blue-600 hover:text-blue-800 font-medium transition"
                >
                  বন্ধ করুন
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-gradient-to-br from-blue-50 to-gray-50 min-h-screen py-12">
        <div className="container mx-auto px-4">
          {/* Success Message with Animation */}
          <div className="text-center mb-12">
            <div className="relative inline-block">
              <FaCheckCircle className="text-green-500 text-6xl md:text-7xl mx-auto mb-4 animate-bounce" />
              {showCoinAnimation && (
                <div className="absolute -top-4 -right-4 bg-yellow-400 text-white rounded-full p-2 animate-ping">
                  <FaCoins className="text-xl" />
                </div>
              )}
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              ধন্যবাদ! আপনার অর্ডারটি সফলভাবে সম্পন্ন হয়েছে
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              আপনার অর্ডার নম্বর: <span className="font-bold text-blue-600">{orderDetails.order_id}</span>
            </p>
          </div>

          {/* Coin Reward Section - Only shown for non-logged-in users */}
          {!isLoggedIn && !isUser && bonus?.first_reg_bonus && (
          <div className="bg-gradient-to-r from-yellow-100 to-yellow-50 rounded-xl shadow-md p-6 mb-12 max-w-2xl mx-auto border border-yellow-200">
            <div className="flex items-center justify-center mb-4">
              <FaGift className="text-yellow-500 text-3xl mr-3" />
              <h2 className="text-2xl font-bold text-yellow-800">অভিনন্দন!</h2>
            </div>
            <div className="flex items-center justify-center bg-white rounded-lg p-4 shadow-inner">
              <FaCoins className="text-yellow-500 text-4xl mr-4" />
              <div>
                <p className="text-lg font-semibold text-gray-800">
                  আপনি {bonus?.first_reg_bonus || 0} {bonus?.coin_name || 'কয়েন'} জিতেছেন!
                </p>
                <p className="text-gray-600 mt-1">
                  পরবর্তী অর্ডারে এই কয়েন ব্যবহার করতে পারবেন।
                </p>
                <p className="text-gray-600 mt-1">
                  ({bonus?.first_reg_bonus || 0} {bonus?.coin_name || 'কয়েন'} = ৳{bonus?.first_reg_bonus || 0})
                </p>
              </div>
            </div>
            <div className="mt-4 bg-blue-50 p-4 rounded-lg border border-blue-100">
              <p className="text-blue-800 font-medium">
                {bonus?.first_reg_bonus || 0} {bonus?.coin_name || 'কয়েন'} ব্যবহার করতে লগিন করুন।
              </p>
              <button 
                className="mt-3 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
                onClick={() => setLoginOpen(true)}
              >
                লগিন করুন
              </button>
            </div>
          </div>
        )}

          {/* Order Details */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden max-w-2xl mx-auto">
            <div className="bg-blue-600 px-6 py-4">
              <h2 className="text-xl font-bold text-white flex items-center">
                <FaShoppingBag className="mr-2" />
                অর্ডার বিবরণ
              </h2>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                      <FaUserAlt className="text-blue-500 mr-2" />
                      গ্রাহক তথ্য
                    </h3>
                    <div className="pl-8">
                      <p className="text-gray-700 mb-1">
                        <span className="font-medium">নাম:</span> {orderDetails.customer_name}
                      </p>
                      <p className="text-gray-700 mb-3">
                        <span className="font-medium">ফোন:</span> {orderDetails.phone_number}
                          {bonus && 
                          <span className="inline-block ml-2 mt-1 bg-green-50 border border-green-200 rounded-lg px-3 py-1 text-sm text-green-800">
                              <span className="font-medium">পন্য ডেলিভারির পরে এই নাম্বারে</span> 
                              <span className="ml-1">
                                {Math.round(orderDetails.product_price * bonus.bonus_percentage/100)} {bonus.coin_name} 
                                <span className="text-green-600 font-bold"> বোনাস</span> যোগ হবে
                              </span>
                          </span>
                        }
                        
                      </p>
                      <p className="text-gray-700">
                        <span className="font-medium">ঠিকানা:</span> {orderDetails.customer_address}
                      </p>
                    </div>
                  </div>

                  {orderDetails.items && orderDetails.items.length > 0 ? (
                    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center border-b pb-2">
                        <FaShoppingBag className="text-blue-500 mr-2" />
                        পণ্য বিবরণ
                      </h3>
                      <div className="space-y-4">
                        {orderDetails.items.map((item, index) => (
                          <div key={index} className="bg-gray-50 rounded-md p-4 border border-gray-100">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                              <p className="text-gray-700">
                                <span className="font-medium text-gray-600">পণ্য:</span> {item.product_name}
                              </p>
                              <p className="text-gray-700">
                                <span className="font-medium text-gray-600">পরিমাণ:</span> {item.quantity}
                              </p>
                              {item.color && (
                                <p className="text-gray-700">
                                  <span className="font-medium text-gray-600">রং:</span> 
                                  <span className="ml-1 px-2 py-1 bg-gray-100 rounded-full text-sm">{item.color}</span>
                                </p>
                              )}
                              {item.size && (
                                <p className="text-gray-700">
                                  <span className="font-medium text-gray-600">সাইজ:</span> 
                                  <span className="ml-1 px-2 py-1 bg-gray-100 rounded-full text-sm">{item.size}</span>
                                </p>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center border-b pb-2">
                        <FaShoppingBag className="text-blue-500 mr-2" />
                        পণ্য বিবরণ
                      </h3>
                      <div className="bg-gray-50 rounded-md p-4 border border-gray-100">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                          <p className="text-gray-700">
                            <span className="font-medium text-gray-600">পণ্য:</span> {orderDetails.product_name}
                          </p>
                          <p className="text-gray-700">
                            <span className="font-medium text-gray-600">পরিমাণ:</span> {orderDetails.quantity}
                          </p>
                          {orderDetails.color && (
                            <p className="text-gray-700">
                              <span className="font-medium text-gray-600">রং:</span> 
                              <span className="ml-1 px-2 py-1 bg-gray-100 rounded-full text-sm">{orderDetails.color}</span>
                            </p>
                          )}
                          {orderDetails.size && (
                            <p className="text-gray-700">
                              <span className="font-medium text-gray-600">সাইজ:</span> 
                              <span className="ml-1 px-2 py-1 bg-gray-100 rounded-full text-sm">{orderDetails.size}</span>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                </div>

                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">মূল্য বিবরণী</h3>
                  <div className="space-y-3">
                    {orderDetails.items && orderDetails.items.length > 0 ? (
                      orderDetails.items.map((item, index) => (
                        <div key={index} className="flex justify-between items-center">
                          <span className="text-gray-600">{item.product_name}</span>
                          <span className="font-medium">৳{item.price} (x{item.quantity}) = ৳{item.price * item.quantity}</span>
                        </div>
                      ))
                    ):
                    <div className="flex justify-between">
                      <span className="text-gray-600">পণ্য মূল্য:</span>
                      <span className="font-medium">৳{orderDetails.product_price}</span>
                    </div>
                    }
                    
                    
                    {/* Order Bumps Section */}
                    {orderDetails.order_bumps && orderDetails.order_bumps.length > 0 && (
                      <div className="border-t border-gray-200 pt-2">
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-gray-600 font-medium">স্পেশাল অফার:</span>
                        </div>
                        {orderDetails.order_bumps.map((bump, index) => (
                          <div key={index} className="flex justify-between items-center pl-4 mb-1">
                            <div className="flex items-center">
                              <FaPlusCircle className="text-blue-500 text-xs mr-2" />
                              <span className="text-gray-600 text-sm">{bump.bump?.title || `অতিরিক্ত পণ্য #${index + 1}`}</span>
                            </div>
                            <span className="font-medium text-sm">৳{bump.price} </span>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {/* Bulk Discount Section */}
                    {orderDetails.bulk_discounts && orderDetails.bulk_discounts.length > 0 && (
                      <div className="border-t border-gray-200 pt-2">
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-gray-600 font-medium">কম্বো ডিসকাউন্ট:</span>
                        </div>
                        {orderDetails.bulk_discounts.map((discount, index) => (
                          <div key={index} className="flex justify-between items-center pl-4 mb-1">
                            <div className="flex items-center">
                              <FaMinusCircle className="text-red-500 text-xs mr-2" />
                              <span className="text-gray-600 text-sm">
                                {discount.title}
                              </span>
                            </div>
                            <span className="font-medium text-sm text-red-600">
                              - ৳{Math.floor(orderDetails.product_price * discount.discount_percentage / 100)}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    <div className="flex justify-between">
                      <span className="text-gray-600">ডেলিভারি চার্জ:</span>
                      <span className="font-medium text-green-600">৳{orderDetails.delivery_charge}</span>
                    </div>
                    {orderDetails.coins_used > 0 && (
                      <div className="flex justify-between text-yellow-600">
                        <span>{bonus.coin_name} ডিসকাউন্ট:</span>
                        <span>- ৳{orderDetails.coins_used} </span>
                      </div>
                    )}
                    {orderDetails.cod_advance > 0 && (
                      <div className="flex justify-between text-yellow-600">
                        <span>অগ্রীম পেমেন্ট:</span>
                        <span>- ৳{orderDetails.cod_advance} </span>
                      </div>
                    )}
                    <div className="border-t border-gray-200 pt-3 mt-3">
                      <div className="flex justify-between font-bold text-lg">
                        <span>মোট পরিশোধ:</span>
                        <span className="text-blue-600">
                          ৳{orderDetails.total}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 bg-green-50 p-4 rounded-lg border border-green-200">
                <div className="flex items-center">
                  <FaTruck className="text-green-500 text-2xl mr-3" />
                  <div>
                    <p className="font-medium text-green-800">আপনার অর্ডারটি প্রস্তুত হচ্ছে!</p>
                    <p className="text-sm text-green-600 mt-1">
                      ২৪-৭২ ঘন্টার মধ্যে ডেলিভারি দেওয়া হবে। ডেলিভারি স্ট্যাটাস জানতে আমাদের হেল্পলাইনে কল করুন।
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Facebook Community Section */}
          {communities.length > 0 && (
            communities.map((community) => {
              const IconComponent = FaIcons[community.icon] || FaIcons.FaFacebook;

              return (
                <div key={community.id} className="mt-8 bg-blue-50 rounded-xl shadow-md overflow-hidden max-w-2xl mx-auto">
                  <div className="bg-blue-700 px-6 py-4"></div>
                  <div className="p-6 text-center">
                    <div className="mb-5">
                      <IconComponent className="w-16 h-16 mx-auto text-blue-600 text-3xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3">{community.name}</h3>
                    <p className="text-gray-600 mb-6">
                      {community.description}
                    </p>
                    <a 
                      href={community.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-md transition duration-300"
                    >
                      <IconComponent className="mr-2" />
                      {community.button_text}
                    </a>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ThankYou;